import { FormikDropdown } from 'common/components';
import { IDropdownOption } from '@fluentui/react';
import { Form, useFormikContext } from 'formik';
import React, { useEffect } from 'react';
import {
  GetDocumentPoolCommonData_documentPoolAvailableDocumentTypes_nodes_extractionTypes,
  GetDocumentPoolCommonData_documentPoolAvailableDocumentTypes_nodes_extractionTypes_nodes,
} from 'documents/__generated__/GetDocumentPoolCommonData';
import { EntityDocuments_entityDocuments_nodes } from 'documents/documentAssignment/folder/list/__generated__/EntityDocuments';
import { EntityDocumentValues } from '../types';
import { DocumentTypeOptions } from 'common/types/utility';

interface CustomDropDownProps {
  isEdit: boolean;
  defaultDocumentTypeId: number | undefined;
  documentData: EntityDocuments_entityDocuments_nodes | null;
  isDocumentProtected: boolean;
  documentOptions?: DocumentTypeOptions[];
  setDocumentType: (data: DocumentTypeOptions) => void;
  setIsAccountingDocument: (isAccounting: boolean | undefined) => void;
  setFileSelected: () => void;
  disabled?: boolean;
  onDocumentTypeChange?: (options: IDropdownOption[]) => void;
  hideExtractionDropdown: () => void;
}

export const CustomDropDown: React.FC<CustomDropDownProps> = ({
  isEdit,
  defaultDocumentTypeId,
  documentData,
  isDocumentProtected,
  documentOptions,
  setDocumentType,
  setIsAccountingDocument,
  setFileSelected,
  disabled,
  onDocumentTypeChange,
  hideExtractionDropdown,
}) => {
  const { values, setFieldValue } = useFormikContext<EntityDocumentValues>();

  useEffect(() => {
    if (defaultDocumentTypeId && !documentData?.id) {
      setFieldValue(
        'entityDocumentTypeId',
        defaultDocumentTypeId ? defaultDocumentTypeId : null
      );
    }
  }, [defaultDocumentTypeId, documentData, documentOptions, setFieldValue]);

  useEffect(() => {
    let extractionTypesArray: GetDocumentPoolCommonData_documentPoolAvailableDocumentTypes_nodes_extractionTypes_nodes[] =
      [];
    extractionTypesArray =
      documentOptions?.find((x) => x.key === values.entityDocumentTypeId)
        ?.extractionTypes.nodes || [];
    onDocumentTypeChange?.(
      extractionTypesArray.map((ele) => ({
        key: ele.id,
        text: ele.extractionType,
      }))
    );
  }, [values.entityDocumentTypeId, documentOptions, onDocumentTypeChange]);

  return (
    <FormikDropdown
      label="Document Type"
      placeholder="Select"
      name="entityDocumentTypeId"
      options={documentOptions || []}
      onChange={(_event, option) => {
        const selectedOptions = option as DocumentTypeOptions;
        setDocumentType(selectedOptions);
        setIsAccountingDocument(selectedOptions.isAccountingDocument!);
        if (selectedOptions.isAccountingDocument) setFileSelected();
        if (isEdit) hideExtractionDropdown();
      }}
      disabled={
        disabled ||
        (!!documentData &&
          (isDocumentProtected || !documentData._isDocumentTypeUpdatable))
      }
      required
    />
  );
};